import { Navigate, type RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import AuthRoute from './AuthRoute';
import SigninPage from '@/pages/auth/signin/Page';
import ResetPasswordPage from '@/pages/auth/reset-password/Page';
import ConfirmPasswordResetPage from '@/pages/auth/reset-password/confirm/Page';

const authPageLayout = (
  <div className='[>_*:flex-1] [>_*:min-h-0] fixed inset-0 flex flex-col'>
    <Outlet />
  </div>
);

export const authRoutes: RouteObject[] = [
  {
    path: '/auth',
    element: <AuthRoute guestOnly />,
    children: [
      {
        element: authPageLayout,
        children: [
          { index: true, element: <Navigate to='signin' replace /> },
          { path: 'signin', element: <SigninPage /> },
          { path: 'reset-password', element: <ResetPasswordPage /> },
        ],
      },
    ],
  },
  {
    path: '/auth/reset-password/confirm',
    element: authPageLayout,
    children: [{ index: true, element: <ConfirmPasswordResetPage /> }],
  },
];
